import React__default from 'react';
import { CartContext } from '../../context/CartContext.esm.js';
import '../../context/CartSettingsContext.esm.js';
import 'tslib';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import { OrderGroupProductTypeEnum } from '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../constants/api.esm.js';
import pluralize from '../../utils/pluralize.esm.js';
import styles from './Cart.module.esm.js';

var CartSummary = function (_a) {
    var _b;
    var isCompact = _a.isCompact;
    var _c = React__default.useContext(CartContext), cart = _c.cart, featureFlags = _c.featureFlags, meta = _c.meta;
    var cartSummary = cart === null || cart === void 0 ? void 0 : cart.cartSummary;
    if (!cartSummary || !cartSummary.reportCount || isCompact)
        return null;
    var _d = cartSummary.billCount, billCount = _d === void 0 ? 0 : _d, _e = cartSummary.kitCount, kitCount = _e === void 0 ? 0 : _e, reportCount = cartSummary.reportCount;
    var isRereq = !!((_b = meta === null || meta === void 0 ? void 0 : meta.rereq) === null || _b === void 0 ? void 0 : _b.isRerequisition);
    var shouldDisplayGeneticWarning = function () {
        var orderGroups = (cart || {}).orderGroups;
        var isProactive = orderGroups === null || orderGroups === void 0 ? void 0 : orderGroups.some(function (item) { return item.productType === OrderGroupProductTypeEnum.Proactive; });
        return isProactive && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.cx_genetic_risk_assessment);
    };
    return (React__default.createElement("p", { "data-testid": "cart-summary" },
        shouldDisplayGeneticWarning() && (React__default.createElement("p", { className: styles.geneticRiskPanelWarning, "data-testid": "genetic-warning" }, "This test is intended to assess risk of hereditary conditions in unaffected patients who are unlikely to meet coverage and policy guidelines.")),
        "This order will be fulfilled as",
        ' ',
        React__default.createElement("strong", null,
            reportCount,
            " ",
            pluralize('report', reportCount)),
        ",",
        ' ',
        isRereq && (React__default.createElement("span", null,
            "at no additional charge and no new specimen is required per Invitae's re-requisition policy.",
            ' ',
            React__default.createElement("a", { href: "https://www.invitae.com/en/re-requisition/", rel: "noopener noreferrer", target: "_blank" }, "Learn more."))),
        !isRereq && (React__default.createElement("span", null,
            "representing",
            ' ',
            React__default.createElement("strong", null,
                billCount,
                " ",
                pluralize('bill', billCount)),
            ", and",
            ' ',
            React__default.createElement("strong", null,
                kitCount,
                " ",
                pluralize('kit', kitCount)),
            ' ',
            "will be required."))));
};

export { CartSummary as default };
//# sourceMappingURL=CartSummary.esm.js.map
